/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab202,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab400,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab401,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab500,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidMonographTabMutationRequest,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidMonographTabMutationResponse,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidMonographTabPathParams,
} from "../../types/courseRegistrationEnrollmentController/PutApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab.ts";
import { courseRegistrationSaveMonographRequestViewModelSchema } from "../courseRegistrationSaveMonographRequestViewModelSchema.ts";

export const putApiV1CourseregistrationEnrollmentCourseregistrationidMonographTabPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidMonographTabPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab202Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab400Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab401Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab500Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab500>;

export const putApiV1CourseregistrationEnrollmentCourseregistrationidMonographTabMutationRequestSchema =
  z.lazy(
    () => courseRegistrationSaveMonographRequestViewModelSchema,
  ) as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidMonographTabMutationRequest>;

export const putApiV1CourseregistrationEnrollmentCourseregistrationidMonographTabMutationResponseSchema =
  z.lazy(
    () =>
      putApiV1CourseregistrationEnrollmentCourseregistrationidMonographTab202Schema,
  ) as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidMonographTabMutationResponse>;
